import { render, staticRenderFns } from "./etiquette.vue?vue&type=template&id=65305498&scoped=true&"
import script from "./etiquette.vue?vue&type=script&lang=js&"
export * from "./etiquette.vue?vue&type=script&lang=js&"
import style0 from "./etiquette.vue?vue&type=style&index=0&id=65305498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65305498",
  null
  
)

export default component.exports